import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Also send bearer token as fallback (for cross-site cookie issues)
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("udyog_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Backend-relative asset paths (e.g. the uploaded brand logo) -> absolute URL.
export const assetUrl = (path) => {
  if (!path) return null;
  if (/^(https?:|data:|blob:)/i.test(path)) return path;
  return `${BACKEND_URL}${path.startsWith("/") ? "" : "/"}${path}`;
};

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}
